module.exports = __webpack_public_path__ + "static/change-wording-maximum-purchase-popup-message-adbf004118f8fcc986b364da3c0b1fc6.png";